import { UnionMap } from '../../types/union-map';

export type SingleDevCenterMisconfigurationType = 'InvalidUri' | 'FailedToFetchOrNotFound';
export const SingleDevCenterMisconfigurationType: UnionMap<SingleDevCenterMisconfigurationType> = {
    InvalidUri: 'InvalidUri',
    FailedToFetchOrNotFound: 'FailedToFetchOrNotFound',
};
